<template>
    <div class="block-warning">
        <i class="icon svg-warning"></i>
        <slot name="message">
          <p>{{ message }}</p>
        </slot>
    </div>
</template>

<script setup lang="ts">
interface IProps {
  message?: string
}

defineProps<IProps>();
</script>

<style lang="scss">
.block-warning {
    display: flex;
    background: rgba(230, 151, 0, 0.1);
    border-radius: 8px;
    padding: 12px;
    color: rgba(207, 117, 41, 1);
    gap: 12px;
    align-items: center;

    i {
        min-width: 18px;
    }

    p, a {
        @include text(14px, 400, #CF7529, 16.8px);
    }

    a {
      text-decoration: underline;
    }
}
</style>
